<template lang='pug'>
  include /mixins
  div
    +b.i-catalog.--variant_col-gap25
      +e.sidebar(:class="{'is_active': isOpen}")
        +b.catalog-title
          +b.H1.ds-caption.--medium.--size_xl.--size_2xxl-xl {{ description }}

        catalog-sidebar(
          :filters="filters"
          :filtersMap="preparedFilters"
          @update:filters="changeFilters"
          :pagination="pagination",
          :attributesResource='attributesResource',
          :additionalResource="additionalResource"
          :label='label'
          :totalItems="totalItems"
          :filterName="filterName"
        )
      +e.content
        +b.i-preloader.--variant_1(:class="{'is-active': loading}")
          +e.item.--size_md

        renderer(
          v-if="result"
          :result="result.data"
        )

        slot(
          v-else
          name="content"
        )

    +b.infinite-sentinel(ref="sentinel" v-if="hasMore")

    +b.ds-panel.--space_md.--space_8xl-xl(
      v-if="pagination.total > pagination.limit"
    )
      +e.element.--offset_top
        ui-limit-pagination(
          :pagination='pagination'
          @input='handlePaginate'
        )
</template>

<script>
import { simplePluralize } from '@utils/strings/pluralize'
import CatalogSidebar from './Sidebar'
import Renderer from './Renderer'
import { mapGetters } from 'vuex'

export default {
  components: {
    CatalogSidebar,
    Renderer,
  },

  props: [
    'result',
    'loading',
    'receive',
    'parameters',
    'filters',
    'filtersMap',
    'changeFilters',
    'pagination',
    'changePagination',
    'attributesResource',
    'additionalResource',
    'label',
    'description',
    'filterName',
    'totalItems',
  ],

  data() {
    return {
      _io: null,
      _armed: true,
    }
  },
  computed: {
    ...mapGetters('ui', ['isOpen']),
    hasMore() {
      const p = this.pagination || {}
      return (p.offset + p.limit) < p.total
    },
    pluralizedProductWord() {
      const variants = [
        this._('товар'),
        this._('товара'),
        this._('товаров'),
      ]
      return simplePluralize(this.totalItems, variants)
    },

    preparedFilters() {
      return this.filtersMap
    },
  },

  mounted() {
    this.setupObserver()
  },
  beforeDestroy() {
    this.teardownObserver()
  },

  watch: {
    pagination: {
      deep: true,
      handler() {
        this._armed = true
        this.$nextTick(this.setupObserver)
      }
    },
    loading(val) {
      if (!val) this._armed = true
    }
  },

  methods: {
    handlePaginate({ limit: limitValue, offset }, cumulative = false) {
      if (this.loading) {
        return
      }
      const needScrollTop = !cumulative
      const baseLimit = limitValue || this.pagination.limit
      const nextLimit = offset + baseLimit
      const currentLimit = this.pagination.limit
      const currentOffset = this.pagination.offset
      const alreadyCumulative = currentOffset === 0
      if (alreadyCumulative && nextLimit <= Math.max(currentLimit, this._maxRequestedLimit)) {
        return
      }

      this._maxRequestedLimit = Math.max(this._maxRequestedLimit, nextLimit)

      this.changePagination({ limit: nextLimit, offset: 0 }, needScrollTop)
    },

    setupObserver() {
      this.teardownObserver()
      if (!this.hasMore) return
      const el = this.$refs.sentinel
      if (!el) return
      const options = {
        root: null,
        rootMargin: '600px 0px 0px 0px',
        threshold: 0
      }
      this._io = new IntersectionObserver(this.onIntersect, options)
      this._io.observe(el)
    },
    teardownObserver() {
      if (this._io) { this._io.disconnect(); this._io = null }
    },
    onIntersect(entries) {
      const e = entries[0]
      if (!e?.isIntersecting) return
      if (!this.hasMore || this.loading || !this._armed) return
      this._armed = false

      const nextOffset = this.pagination.offset + this.pagination.limit

      setTimeout(() => {
        this.handlePaginate({ limit: this.pagination.limit, offset: nextOffset }, true)
      }, 50)
    },
  },
}

</script>
